import React from "react";
import emailjs from "@emailjs/browser";
import { toast, Toaster } from "react-hot-toast";

const Contact = () => {
    const sendMail = (event) => {
        event.preventDefault();

        emailjs
            .sendForm(
                "service_0kwh0fv",
                "template_f6x9phu",
                event.target,
                "eHuS9iHh0LRpBGpxd"
            )
            .then((res) => {
                toast.success("Your message is send.Thank You.");
                event.target.reset();
            })
            .catch((error) => console.error(error));
    };
    return (
        <div className="mt-28 mb-20 w-[90%] px-3 md:w-3/4 mx-auto">
            <Toaster position="top-center" reverseOrder={false} />
            <div className="text-center">
                <h2 className="font-extrabold uppercase text-4xl dark:text-[#E9F8F9]">
                    Contacts
                </h2>
                <p className="dark:text-[#E9F8F9]">
                    ./ <span className="underline">contact</span>|
                </p>
            </div>

            <div className="mt-16">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14612.03578509453!2d90.48331503998459!3d23.71137455997758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b7b9613db347%3A0x57a6864a9e446e20!2sHaji%20Nizamuddin%20Tower!5e0!3m2!1sen!2sbd!4v1676110058313!5m2!1sen!2sbd"
                    width="950"
                    height="450"
                    style={{ border: 3 }}
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                    title="location"
                    className="rounded-md"
                ></iframe>
            </div>
            <div className="mt-16">
                <h3 className="font-extrabold uppercase text-xl dark:text-[#E9F8F9]">
                    Let's Talk
                </h3>
                <form onSubmit={sendMail}>
                    <input
                        name="name"
                        className="block border-b focus:outline-1 my-8 w-full py-4 pl-3 rounded-md shadow-md dark:shadow-[#7286D3]"
                        type="text"
                        placeholder="Name"
                        required
                    />
                    <input
                        name="user-email"
                        className="block border-b focus:outline-1 my-8 w-full py-4 pl-3 rounded-md shadow-md dark:shadow-[#7286D3]"
                        type="email"
                        placeholder="Email"
                        required
                    />
                    <textarea
                        className="block border-b focus:outline-1 mb-5 w-full rounded-md py-4 pl-3 shadow-md dark:shadow-[#7286D3]"
                        name="message"
                        placeholder="Massage"
                        required
                    ></textarea>
                    <input
                        className="bg-gradient-to-r rounded-md from-[#7286D3] to-[#8d9dcf] text-white px-6 py-2 cursor-pointer"
                        type="submit"
                        value="Get in touch"
                    />
                </form>
            </div>
        </div>
    );
};

export default Contact;
